import { toast } from "react-toastify";
import { API_ROUTES } from "../../utils/constants";
import AppSecureStorage from "../secureStorage";
import { AxiosBase } from "./index";

const storage = new AppSecureStorage();

export default class AnalyticsService extends AxiosBase {
  getAnalyticsData = async ({ startDate, endDate, navigate }) => {
    try {
      const response = await this.requests.get(
        `${
          API_ROUTES.ANALYTICS.GET_ANALYTICS_DATA
        }?startDate=${startDate}&endDate=${endDate}&orgId=${storage.get(
          "orgId"
        )}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data.error);
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getAnalyticsByOrgId = async ({ startDate, endDate, orgId, navigate }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_ANALYTICS_DATA_SUPER_ADMIN}?startDate=${startDate}&endDate=${endDate}&orgId=${orgId}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data.error);
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getBillingAnalyticsData = async ({ startDate, endDate, navigate }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_BILLING_ANALYTICS_DATA}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data.error);
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  // getExportDashboardReportData = async ({ startDate, endDate, navigate }) => {
  //   try {
  //     const response = await this.requests.post(
  //       `${API_ROUTES.ANALYTICS.EXPORT_DASHBOARD_REPORT}?startDate=${startDate}&endDate=${endDate}`,
  //       {},
  //       { responseType: "arraybuffer" }
  //     );
  //     return response;
  //   } catch (err) {
  //     toast.error(err?.data.error);
  //     if (err?.status === 401) {
  //     }
  //     throw err;
  //   }
  // };
  getBillingAnalyticsDataByOrg = async ({
    startDate,
    endDate,
    orgId,
    navigate,
  }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_BILLING_ANALYTICS_DATA_SUPER_ADMIN}?startDate=${startDate}&endDate=${endDate}&orgId=${orgId}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data.error);
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getActionWiseAnalytics = async ({ startDate, endDate, orgId, navigate }) => {
    try {
      const organisationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_ACTION_WISE_ANALYTICS}/${organisationId}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch action-wise analytics");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getFeedbackActionWiseAnalytics = async ({ startDate, endDate, orgId, navigate }) => {
    try {
      const organisationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_ACTION_WISE_ANALYTICS}/${organisationId}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch feedback action-wise analytics");
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getTotalActionStats = async ({ orgId, navigate }) => {
    try {
      const organisationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_TOTAL_ACTION_STATS}/${organisationId}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch total action stats");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getDashboardData = async ({ startDate, endDate, orgId, navigate }) => {
    try {
      const orgainzationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_DASHBOARD_DATA}/${orgainzationId}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch dashboard data");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getActiveUsers = async ({ startDate, endDate, orgId, navigate }) => {
    try {
      const orgainzationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_ACTIVE_USERS}/${orgainzationId}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch active users");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getUsersPerAction = async({startDate, endDate, action, navigate})=>{
    try{
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_USERS_PER_ACTION}?startDate=${startDate}&endDate=${endDate}&action=${action}`
      )
      return response;
    }catch(err){
      toast.error(err?.data?.error || "Failed to fetch users per action");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getUserWiseActions = async ({ startDate, endDate, navigate }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_USER_WISE_ACTIONS}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch user-wise actions");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getActionWisePerformance = async ({
    startDate,
    endDate,
    orgId,
    navigate,
  }) => {
    try {
      const orgainzationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_ACTION_WISE_PERFORMANCE}/${orgainzationId}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(
        err?.data?.error || "Failed to fetch Action Wise Performance"
      );
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getFeedbackStats = async ({ startDate, endDate, orgId, navigate }) => {
    try {
      const orgainzationId = orgId || storage.get("orgId");
      const response = await this.requests.get(
        `${API_ROUTES.ANALYTICS.GET_FEEDBACK_STATS}/${orgainzationId}?startDate=${startDate}&endDate=${endDate}`
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch Feedback Stats");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getNotSatisfiedRequests = async ({ orgId, startDate, endDate, page = 1, limit = 20, name = "", action = "", navigate }) => {
    try {
      const organisationId = orgId || storage.get("orgId");
      let url = `${API_ROUTES.ANALYTICS.GET_NOT_SATISFIED_REQUESTS}/${organisationId}?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
      if (name && name.trim()) {
        url += `&name=${encodeURIComponent(name.trim())}`;
      }
      if (action && action.trim()) {
        url += `&action=${encodeURIComponent(action.trim())}`;
      }
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to fetch Not Satisfied Requests");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  exportActionsUsersAnalytics = async ({ startDate, endDate, navigate }) => {
    try {
      const response = await this.instance.post(
        `${API_ROUTES.ANALYTICS.EXPORT_ACTIONS_USERS_ANALYTICS}?startDate=${startDate}&endDate=${endDate}`,
        {},
        { responseType: "arraybuffer" }
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to export actions/users analytics");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  addAdminComment = async ({ id, comment }) => {
    try {
      const response = await this.requests.post(
        `/feedback/${id}/add-comment`,
        { comment }
      );
      return response;
    } catch (err) {
      toast.error(err?.data?.error || "Failed to add admin comment");
      if (err?.status === 401) {
      }
      throw err;
    }
  };
}
